import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  insuranceGroupName: {
    id: 'containers.PatientIntakeFormAnswersPage.components.InsuranceCapture.insuranceGroupName',
    defaultMessage: 'Group ID',
  },
  memberName: {
    id: 'containers.PatientIntakeFormAnswersPage.components.InsuranceCapture.memberName',
    defaultMessage: 'Name',
  },
  startDate: {
    id: 'containers.PatientIntakeFormAnswersPage.components.InsuranceCapture.startDate',
    defaultMessage: 'Start date',
  },
  endDate: {
    id: 'containers.PatientIntakeFormAnswersPage.components.InsuranceCapture.endDate',
    defaultMessage: 'End date',
  },
  memberNumber: {
    id: 'containers.PatientIntakeFormAnswersPage.components.InsuranceCapture.memberNumber',
    defaultMessage: 'Member ID',
  },
  payerName: {
    id: 'containers.PatientIntakeFormAnswersPage.components.InsuranceCapture.payerName',
    defaultMessage: 'Payer name',
  },
  primaryInsurance: {
    id: 'containers.PatientIntakeFormAnswersPage.components.InsuranceCapture.primaryInsurance',
    defaultMessage: 'Primary Insurance',
  },
  additionalInsurance: {
    id: 'containers.PatientIntakeFormAnswersPage.components.InsuranceCapture.additionalInsurance',
    defaultMessage: 'Additional Insurance',
  },
  planStatus: {
    id: 'containers.PatientIntakeFormAnswersPage.components.InsuranceCapture.planStatus',
    defaultMessage: 'Plan status',
  },
  active: {
    id: 'containers.PatientIntakeFormAnswersPage.components.InsuranceCapture.active',
    defaultMessage: 'Active',
  },
  inactive: {
    id: 'containers.PatientIntakeFormAnswersPage.components.InsuranceCapture.inactive',
    defaultMessage: 'Inactive',
  },
  eligibilityResult: {
    id: 'containers.PatientIntakeFormAnswersPage.components.InsuranceCapture.eligibilityResult',
    defaultMessage: 'Eligibility result',
  },
  eligibilityCheckAt: {
    id: 'containers.PatientIntakeFormAnswersPage.components.InsuranceCapture.eligibilityCheckAt',
    defaultMessage: 'Eligibility check at ',
  },
  subscriberDetails: {
    id: 'containers.PatientIntakeFormAnswersPage.components.InsuranceCapture.subscriberDetails',
    defaultMessage: 'Subscriber details {relationshipToSubscriber}',
  },
  subscriberDateOfBirth: {
    id: 'containers.PatientIntakeFormAnswersPage.components.InsuranceCapture.subscriberDateOfBirth',
    defaultMessage: 'Date of birth',
  },
  relationshipToSubscriber: {
    id: 'containers.PatientIntakeFormAnswersPage.components.InsuranceCapture.relationshipToSubscriber',
    defaultMessage: 'Relationship to subscriber',
  },
  insuranceTitle: {
    id: 'containers.PatientIntakeFormAnswersPage.components.InsuranceCapture.insuranceTitle',
    defaultMessage: 'Insurance Information',
  },
  eligible: {
    id: 'containers.PatientIntakeFormAnswersPage.components.InsuranceCapture.Eligible',
    defaultMessage: 'Eligible - {date}',
  },
  notEligible: {
    id: 'containers.PatientIntakeFormAnswersPage.components.InsuranceCapture.notEligible',
    defaultMessage: 'Not eligible - {date}',
  },
  eligibilityFailed: {
    id: 'containers.PatientIntakeFormAnswersPage.components.InsuranceCapture.eligibilityFailed',
    defaultMessage: 'Failed to run - {date}',
  },
  unknown: {
    id: 'containers.PatientIntakeFormAnswersPage.components.InsuranceCapture.unknown',
    defaultMessage: 'Unknown - {date}',
  },
});
